import React, { useRef, useState } from "react";
import "./utils.css";
import { motion } from "framer-motion";
import load from "../assets/spin.gif";
import { Link, useNavigate } from "react-router-dom";
import {
  ArrowDown2,
  ArrowLeft,
  ArrowLeft2,
  Calendar,
  Copy,
  Eye,
  EyeSlash,
  SearchNormal,
} from "iconsax-react";

export const Btn = ({
  btnClass,
  btnText,
  btnClick,
  href,
  loading,
  disabled,
  err,
  btnLink,
  leftIcon,
  rightIcon,
  btnWidth,
}) => {
  const submitBtn = (e) => {
    e.preventDefault();
    if (btnClick) {
      btnClick();
    }
  };

  return (
    <div>
      {href && (
        <a
          href={href}
          target={"_blank"}
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <motion.button
            className={btnClass}
            whileTap={{ scale: 0.85 }}
            style={{ width: btnWidth }}
          >
            {leftIcon}
            {btnText}
            {rightIcon}
          </motion.button>
        </a>
      )}
      {btnLink && (
        <Link to={btnLink} style={{ textDecoration: "none" }}>
          <motion.button
            className={btnClass}
            whileTap={{ scale: 0.85 }}
            style={{ width: btnWidth }}
          >
            {leftIcon}
            {btnText}
            {rightIcon}
          </motion.button>
        </Link>
      )}
      {btnClick && (
        <motion.button
          className={disabled ? `opacity ${btnClass}` : btnClass}
          whileTap={{ scale: 0.85 }}
          onClick={(e) => submitBtn(e)}
          style={{ width: btnWidth }}
          disabled={disabled}
        >
          {leftIcon}
          {loading ? (
            <img
              style={{ width: "40px", height: "40px" }}
              src={load}
              alt="loading"
            />
          ) : (
            btnText
          )}{" "}
          {btnText === "Copy" && <Copy />}
          {rightIcon}
        </motion.button>
      )}
      {err && (
        <p
          style={{
            color: "red",
            fontSize: "12px",
            textAlign: "left",
            width: "100%",
          }}
        >
          {err}
        </p>
      )}
    </div>
  );
};

export const Goback = ({ goText }) => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };
  return (
    <div>
      <button
        onClick={goBack}
        className="go-back"
        style={goText && { padding: 0 }}
      >
        {goText ? <ArrowLeft2 color="#011F1B" size={24} /> : <ArrowLeft />}
        {goText && <p>{goText}</p>}
      </button>
    </div>
  );
};

export const FormTextArea = ({
  label,
  placeholder,
  changeInput,
  labelBg,
  err,
  ...rest
}) => {
  const handleDataChange = (e) => {
    if (changeInput) {
      changeInput(e);
    }
  };

  return (
    <>
      <div className="input-cont text-cont">
        <label htmlFor={label} style={{ background: labelBg }}>
          {label}
        </label>
        <textarea
          name={label}
          id={label}
          placeholder={placeholder}
          onChange={(e) => handleDataChange(e)}
          {...rest}
        ></textarea>
      </div>
      {err && (
        <p
          style={{
            color: "red",
            fontSize: "14px",
            textAlign: "left",
            width: "100%",
            fontFamily: "Work Sans",
          }}
        >
          {err}
        </p>
      )}
    </>
  );
};

export const FormSearch = ({ serStyle, changeInput, ...rest }) => {
  const handleDataChange = (e) => {
    if (changeInput) {
      changeInput(e);
    }
  };

  return (
    <div className="search-cont" style={serStyle}>
      <input
        {...rest}
        type={"text"}
        onChange={(e) => handleDataChange(e)}
        style={{ flex: 1 }}
      />
      <SearchNormal size={24} color="#B0B0B0" />
    </div>
  );
};

export const FormInput = ({
  label,
  type,
  err,
  isPassword,
  changeInput,
  labelBg,
  req,
  inputBg,
  inputStyle,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleDataChange = (e) => {
    if (changeInput) {
      changeInput(e);
    }
  };

  const clickEye = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="input-container" style={inputStyle}>
      <div className="input-cont">
        <label htmlFor={label} style={{ background: labelBg }}>
          {label}
          {req && <img src={req} alt="req" className="req_img" />}
        </label>
        <input
          {...rest}
          type={
            isPassword && !showPassword
              ? "password"
              : isPassword && showPassword
              ? "text"
              : !isPassword
              ? type
              : ""
          }
          onChange={(e) => handleDataChange(e)}
          style={inputBg}
        />
        {isPassword && (
          <div className="icon-div">
            {!showPassword && (
              <Eye
                style={{ cursor: "pointer" }}
                onClick={clickEye}
                size={24}
                color="rgba(115, 116, 117, 0.75)"
              />
            )}
            {showPassword && (
              <EyeSlash
                style={{ cursor: "pointer" }}
                onClick={clickEye}
                size={24}
                color="rgba(115, 116, 117, 0.75)"
              />
            )}
          </div>
        )}
      </div>
      <p style={{ fontFamily: "Work Sans", color: "red" }}>{err}</p>
    </div>
  );
};

export const FormCheckbox = ({ changeInput, ...rest }) => {
  const handleDataChange = (e) => {
    if (changeInput) {
      changeInput(e);
    }
  };

  return (
    <div className="checkbox">
      <input
        type="checkbox"
        name="custom-checkbox"
        id="custom-checkbox"
        onChange={(e) => handleDataChange(e)}
        {...rest}
      />
      <label htmlFor="custom-checkbox"></label>
    </div>
  );
};

export const OTPInput = ({ length = 6, onChange }) => {
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputRefs = useRef([]);

  const handleChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value.slice(0, 1);
    setOtp(newOtp);

    // Move focus to the next box if available
    if (value && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    // Pass the OTP value to the parent component
    if (onChange) {
      onChange(newOtp.join(""));
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);

      // Move focus to the previous box if available
      if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }

      if (onChange) {
        onChange(newOtp.join(""));
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").slice(0, length);
    const newOtp = pasteData.split("");
    for (let i = 0; i < length; i++) {
      if (newOtp[i]) {
        otp[i] = newOtp[i];
        inputRefs.current[i].value = newOtp[i];
      }
    }
    setOtp([...otp]);
    if (onChange) onChange(newOtp.join(""));
  };

  return (
    <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
      {otp.map((_, index) => (
        <input
          key={index}
          type="text"
          maxLength="1"
          value={otp[index]}
          ref={(el) => (inputRefs.current[index] = el)}
          onChange={(e) => handleChange(e.target.value, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={handlePaste}
          style={{
            width: "40px",
            height: "40px",
            textAlign: "center",
            fontSize: "18px",
            border: "2px solid #ddd",
            borderRadius: "4px",
            outline: "none",
            transition: "border-color 0.3s ease",
            fontFamily: "Work Sans",
          }}
        />
      ))}
    </div>
  );
};

export const SelectInput2 = ({
  options = [],
  onChange,
  label,
  getItem,
  labelBg,
  req,
  id,
  err,
}) => {
  return (
    <div className="input-container input-select_cont">
      <div className="input-cont">
        <label htmlFor={label} style={{ background: labelBg }}>
          {label}
          {req && <img src={req} alt="req" className="req_img" />}
        </label>
        <div className="select-arrow">
          <ArrowDown2 size={18} color="#737475" />
        </div>
        <select
          className="input-select"
          onChange={(e) => {
            const selectedId = e.target.value;
            const selectedItem = options.find((opt) => opt.id === selectedId);
            if (getItem) {
              getItem(selectedItem);
            }
            onChange(selectedId);
          }}
        >
          <option value="Select an option" disabled selected>
            Select an option
          </option>
          {options.map((option, index) => (
            <option key={index} value={option.id} id={id}>
              {option.name || option.blockName}
            </option>
          ))}
        </select>
      </div>
      {err && <p style={{ color: "red" }}>{err}</p>}
    </div>
  );
};
export const SelectInput = ({ options = [], onChange }) => {
  return (
    <div className="custom-select-container">
      <div className="arrow">
        <ArrowDown2 size={18} color="#f08228" />
      </div>
      <select
        className="custom-select"
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="Select an option" disabled>
          Select an option
        </option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export const ErrorComp = ({ message }) => {
  return (
    message && (
      <div className="error-comp">
        <p>{message}</p>
      </div>
    )
  );
};
export const SuccessComp = ({ message }) => {
  return (
    message && (
      <div className="success-comp">
        <p>{message}</p>
      </div>
    )
  );
};

export const getFirstString = (text) => {
  return text?.trim()?.split(/\s+/)[0] || "";
};

export const trimText = (text) => {
  return text.length > 50 ? text.slice(0, 50) + "..." : text;
};

export const validateRequiredFields = (data, requiredFields) => {
  return Object.entries(requiredFields).every(([key, isRequired]) => {
    if (!isRequired) return true;

    const value = data[key];

    if (typeof value === "boolean") return value === true;

    return value?.toString().trim() !== "";
  });
};

export const formatDisplayDate = (dateStr) => {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  return `${day}/${month}/${year}`;
};

export const truncateText = (text, limit = 8) => {
  if (!text) return "";
  return text.length > limit ? text.slice(0, limit) + "..." : text;
};

export const DatePicker = ({date, setDate}) => {
  return (
    <div className="datePickerWrapper">
      <div className="date_ph">
        <div className="date_ph_left">
          <Calendar size={12} color="#ACACAC" />
          <p>{date}</p>
        </div>
        <ArrowDown2 size={12} color="#ACACAC" />
      </div>
      <input
        type="date"
        className="datePickerInput"
        // value={date}
        onChange={(e) => setDate(formatDisplayDate(e.target.value))}
      />
    </div>
  );
};

export const toISODate = (dateStr) => {
  const [d, m, y] = dateStr.split("/");
  return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
};
